import { render, staticRenderFns } from "./ac-kanban.vue?vue&type=template&id=5dc4568b&"
import script from "./ac-kanban.vue?vue&type=script&lang=js&"
export * from "./ac-kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports